/**
* @name APP u-Planning
* @autor over.martinez@u-planner.com
* @description
* Descripcion del controlador
* @controller 
* # name: listTransversalProjectsCtrl
* # alias: listTPCtrl
*/

export default class listTransversalProjectsCtrl {

	constructor($scope, $state, $stateParams, ngNotify, UserInfoConstant, $mdDialog, $cookies, WorkPlanSrv) {
		this.$state = $state
		this.$scope = $scope
		this.$stateParams = $stateParams
		this.$cookies = $cookies
		this.tacherName = $cookies.get('adminName')
		this.ngNotify = ngNotify
		this.$mdDialog = $mdDialog
		this.WorkPlanSrv = WorkPlanSrv

		this.$scope.UserInfoConstant = UserInfoConstant
		this.$scope.$watch('UserInfoConstant[0].details[0]', (details) => {
			if (details !== undefined) {
				this.userinfo = details.user
				this.main()
			}
		})

	}

	main() {
		this.listTransversal()
	}

	close(){
		return this.$mdDialog.hide()
	}

	listTransversal() {
		this.WorkPlanSrv.getListProjectsCross.post().$promise.then((result) => {
	        if (!result.status) {
	          ngNotify.set('Error al conectar con el servicio', 'error')
	        } else {
	          this.ProjectsCross = result.data
 	          this.detailTransversal({transversalProjectsId:this.ProjectsCross[0].transversalProjectsId})
	        }
      	}, (err) => {
        	ngNotify.set('Imposible conectar con el servicio', 'error')
      	})


	}

	detailTransversal(data) {
		let params = {
			transversalProjectsId : data.transversalProjectsId
		}

		this.status = false

		this.WorkPlanSrv.getProjectsCrossById.get(params).$promise.then((result) => {
	        if (!result.status) {
	          ngNotify.set('Error al conectar con el servicio', 'error')
	        } else {
	          this.DetailProjectsCross = result.data
	          this.status = result.status
	        }
      	}, (err) => {
        	ngNotify.set('Imposible conectar con el servicio', 'error')
      	})
	}
}



listTransversalProjectsCtrl.$inject = ['$scope', '$state', '$stateParams', 'ngNotify', 'UserInfoConstant', '$mdDialog', '$cookies', 'WorkPlanSrv']


// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/extensionVisibility/modals/listTransversalProjectsCtrl.js